import React, {useState} from 'react';
import {COLORS} from '@fupa/fupa-uikit';
import {EmailAndPasswordSignUp} from 'app/services/firebase';
import styled from 'styled-components';
import {useHistory} from 'react-router';
import {useForm} from 'react-hook-form';
import {isAtInAddress, isFilled, isValidEmailAddress} from 'app/components/helpers/ValidationRules';
import {StyledButton} from 'app/styles/content';
import {IconButton, InputAdornment, TextField} from '@mui/material';
import {Visibility, VisibilityOff} from '@mui/icons-material';
import {useSelector} from 'react-redux';
import {selectButtonType} from 'app/hooks/reduxCreateSelectorHooks';
import {sendEventToGA4} from 'app/components/helpers/gtagHelpers';
import {setSentryTags} from 'app/services/sentry';

const Container = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const EmailFormSignUp = ({setShowLoading, onError}) => {
  const buttonType = useSelector(selectButtonType);
  const [showPassword, setShowPassword] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const {register, handleSubmit, errors} = useForm({
    mode: 'onBlur',
    reValidateMode: 'onChange',
  });
  const history = useHistory();

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = event => {
    event.preventDefault();
  };

  const onSubmit = ({email, password}) => {
    // function is only called, when inputs are valid
    // Reset error in case form is submitted a second time
    onError(null, '');
    setDisableButton(true);
    setShowLoading(true);
    EmailAndPasswordSignUp(email, password)
      .then(() => {
        setSentryTags({name: 'sign_up_step', value: 'firebase_account_created'});
        setSentryTags({name: 'method', value: 'password'});
        sendEventToGA4('sign_up', {method: 'password'});
        history.push('/auth/finish-signup');
      })
      .catch(error => {
        setDisableButton(false);
        setShowLoading(false);
        onError(error, email);
      });
  };

  return (
    <Container onSubmit={handleSubmit(onSubmit)}>
      <TextField
        variant="standard"
        autoComplete='email'
        autoFocus={true}
        color='secondary'
        error={!!errors.email}
        helperText={errors.email ? errors.email.message : ' '}
        id='email-signup'
        InputLabelProps={{required: false}}
        inputProps={{tabIndex: '1'}}
        inputRef={register({
          validate: {
            isFilled,
            isAtInAddress,
            isValidEmailAddress,
          },
        })}
        label='E-Mail'
        name='email'
        placeholder='max.mustermann@mail.de'
        required={true}
        type='email' />
      <TextField
        variant="standard"
        autoComplete='new-password'
        color='secondary'
        error={!!errors.password}
        helperText={errors.password ? errors.password.message : 'Mindestens 6 Zeichen'}
        id='password-signup'
        InputLabelProps={{required: false}}
        inputProps={{tabIndex: '1'}}
        inputRef={register({
          validate: isFilled,
          minLength: {
            value: 6,
            message: 'Bitte gib mindestens 6 Zeichen ein.',
          },
        })}
        label='Passwort'
        name='password'
        placeholder='********'
        required={true}
        type={showPassword ? 'text' : 'password'}
        InputProps={{
          endAdornment: (
            <InputAdornment position='end'>
              <IconButton
                tabIndex='1'
                aria-label='Ändern der Sichtbarkeit des Passworts'
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                size="large">
                {showPassword ? (
                  <VisibilityOff style={{color: COLORS.darkGrey}} />
                ) : (
                  <Visibility style={{color: COLORS.darkGrey}} />
                )}
              </IconButton>
            </InputAdornment>
          ),
        }} />
      <StyledButton disabled={disableButton} tabIndex='1' justify='center' type={buttonType} label='Registrieren' />
    </Container>
  );
};

export {EmailFormSignUp};
